import { JsonError } from '../errors/did-json-error';
import { FaceRect } from './IFaceSquare';

export enum AvatarStatus {
    Created = 'created',
    Draft = 'draft',
    Done = 'done',
    Error = 'error',
    PostDone = 'post-done',
    Rejected = 'rejected',
    Started = 'started',
    TrainingStarted = 'training-started',
    Uploading = 'uploading',
    Validating = 'validating',
}

export const enum A2eModel {
    Baseline = 'Baseline (default)',
    Finetuned = 'Finetuned',
}

export interface SceneAvatar {
    id: string;
    object: 'scene_avatar';
    created_at: string;
    created_by: string;
    status: AvatarStatus;
    owner_id: string;
    modified_at: string;
    error?: JsonError;
    started_at?: string;
    completed_at?: string;
    name?: string;
    image_url?: string;
    thumbnail_url?: string;
    preview_url?: string;
    talking_preview_url?: string;
    webhook?: string;
    source_duration?: number;
    source_url?: string;
    consent_id?: string;
    voice_id?: string;
    is_green_screen?: boolean;
    face_rect?: FaceRect;
}
